import { ActivatedRouteSnapshot } from "@angular/router";
import { STRING } from "../constants/string";
import { AppLocalizationRoute } from "../types.local";
import { AppLocalizationRouteData } from "../types";

export const getPathOfRoute = ({ firstChild, url, data }: ActivatedRouteSnapshot, parentUrl: string[] = []): AppLocalizationRoute[] => {
  const list: AppLocalizationRoute[] = [];
  // Construct the route URL
  const routeUrl = parentUrl.concat(url.map(url => url.path));

  if (url.length) {
    list.push({
      data: data as AppLocalizationRouteData,
      path: `${STRING.SLASH}${routeUrl.join(STRING.SLASH)}`,
    });
  }

  // Add another element for the next route part
  return list.concat(firstChild ? getPathOfRoute(firstChild, routeUrl) : []);
};
